module.exports = __webpack_public_path__ + "img/order.6c1d24a2.svg";